<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="05" :question="question"></QuestionTitle>
        <div class="container-70 mt-20px">
            <SelectOptionBox :img="imgAlimentation" :options="options" v-model="result"></SelectOptionBox>
            <div v-if="result != null" @click="saveAndContinue('residenceType', JSON.stringify(result), './question-6')"
                class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine class="mt-50px" percent="80%"></AvancementLine>
        </div>
        <ModalInfo @closeModal="modalActive = false" v-if="modalActive">
            <h3 class="modal-title">GES émis par votre habitation</h3>
            <p class="modal-text">Les GES émis par un bâtiment relèvent principalement de la consommation énergétique nécessaire pour le chauffer. Plusieurs facteurs déterminent la quantité de GES émis, tels que la source d'énergie utilisée, les besoins et habitudes de consommation d'énergie, la performance énergétique du bâtiment, ainsi que sa superficie.</p>
        </ModalInfo>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import SelectOptionBox from '@/components/SelectOptionBox.vue'
import ModalInfo from '@/components/ModalInfo.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result: null,
            question: 'Quelle est la source d\'énergie principale que vous utilisez pour alimenter votre lieu de résidence?',
            imgAlimentation: require('@/assets/images/windturbines.png'),
            options: [
                {
                    label: "Électrique seulement",
                    value: "Électrique seulement"
                },
                {
                    label: "Gaz naturel, propane ou mazout",
                    value: "Gaz naturel, propane ou mazout"
                },
                {
                    label: "Bois et électricité",
                    value: "Bois et électricité"
                }
            ]

        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        SelectOptionBox,
        ModalInfo
    },
    mixins: [utils],
    mounted() {
        if (sessionStorage.getItem('residenceType')) {
            this.result = JSON.parse(sessionStorage.getItem('residenceType'))
        }
    }
}
</script>